const maximumKrw = BigInt(2147483647);
const denominator = BigInt(10000);
function settlementInteger(offered, rate) {
    const numerator = BigInt(offered) * BigInt(rate) + BigInt(5000);
    const commission = numerator / denominator -
        (numerator < BigInt(0) && numerator % denominator !== BigInt(0)
            ? BigInt(1)
            : BigInt(0));
    return BigInt(offered) - commission;
}
export function getMaximumReservationSettlementPrice(declaredPrice, commissionRateBps) {
    const amount = settlementInteger(declaredPrice, commissionRateBps);
    return Number(amount > maximumKrw ? maximumKrw : amount);
}
/** Shared by ERP forms and the server. All money is integer KRW. */
export function resolveReservationVehiclePrice(declaredPrice, commissionRateBps, input, currentOfferedPrice) {
    if (!Number.isInteger(declaredPrice) ||
        declaredPrice < 0 ||
        declaredPrice > 2147483647 ||
        !Number.isSafeInteger(commissionRateBps) ||
        commissionRateBps > 10000) {
        throw new RangeError('신고 대여요금과 수수료율을 확인해주세요.');
    }
    const settlement = (offered) => settlementInteger(offered, commissionRateBps);
    const maximumSettlement = getMaximumReservationSettlementPrice(declaredPrice, commissionRateBps);
    let offeredPrice = input.value;
    if (input.kind === 'discount') {
        if (!Number.isFinite(input.value) || input.value < 0 || input.value > 100)
            throw new RangeError('할인율은 0~100 사이로 입력해주세요.');
        offeredPrice = Math.round(declaredPrice * (1 - input.value / 100));
    }
    else if (input.kind === 'settlement') {
        if (!Number.isInteger(input.value) ||
            input.value < 0 ||
            input.value > maximumSettlement) {
            throw new RangeError(`정산가는 0~${maximumSettlement.toLocaleString()}원 사이의 정수로 입력해주세요.`);
        }
        if (currentOfferedPrice != null &&
            Number.isInteger(currentOfferedPrice) &&
            currentOfferedPrice >= 0 &&
            currentOfferedPrice <= declaredPrice &&
            settlement(currentOfferedPrice) === BigInt(input.value)) {
            offeredPrice = currentOfferedPrice;
        }
        else {
            // Find the smallest offered price that produces exactly the entered net price.
            // Negative rates can skip net values; reject those instead of changing the requested amount.
            let low = 0;
            let high = declaredPrice;
            while (low < high) {
                const middle = Math.floor((low + high) / 2);
                if (settlement(middle) < BigInt(input.value))
                    low = middle + 1;
                else
                    high = middle;
            }
            offeredPrice = low;
            if (settlement(offeredPrice) !== BigInt(input.value)) {
                throw new RangeError(`현재 수수료율에서는 정산가를 ${Number(settlement(Math.max(0, offeredPrice - 1))).toLocaleString()}원${settlement(offeredPrice) <= maximumKrw ? ` 또는 ${Number(settlement(offeredPrice)).toLocaleString()}원` : ''}으로 입력해주세요.`);
            }
        }
    }
    if (!Number.isInteger(offeredPrice) ||
        offeredPrice < 0 ||
        offeredPrice > declaredPrice) {
        throw new RangeError('제공가는 0원 이상 신고 대여요금 이하의 정수로 입력해주세요.');
    }
    const rawSettlement = settlement(offeredPrice);
    if (rawSettlement > maximumKrw)
        throw new RangeError('정산가가 저장 가능한 금액 범위를 초과합니다.');
    const settlementPrice = Number(rawSettlement);
    return {
        offeredPrice,
        settlementPrice,
        commissionAmount: offeredPrice - settlementPrice,
        discountRate: declaredPrice > 0
            ? Math.round(((declaredPrice - offeredPrice) / declaredPrice) * 1000) /
                10
            : 0,
    };
}
/** Effective booking commission; the configured vendor rate remains unchanged. */
export function getReservationActualCommission(offeredPrice, settlementPrice) {
    if (![offeredPrice, settlementPrice].every((value) => Number.isInteger(value) && value >= 0 && value <= 2147483647)) {
        throw new RangeError('차량요금은 0원 이상 정수로 입력해주세요.');
    }
    const amount = offeredPrice - settlementPrice;
    return {
        amount,
        rate: offeredPrice === 0
            ? null
            : Math.round((amount / offeredPrice) * 10000) / 100,
    };
}
